(function () {

  'use strict';

  eclipseApp.directive('uteFooter', ['$rootScope', '$http', '$compile', 'uteEndpoint', 'uteLocale', function ($rootScope, $http, $compile, uteEndpoint, uteLocale) {

    return {
      restrict: 'E',
      scope: true,
      replace: false,
      // templateUrl: 'modules/core/views/fido-footer.html',
      template: '',
      link: function ($scope, $element, $attr) {

        $scope.isCms = $attr.isCms;

        if ($scope.isCms.toLowerCase() === 'true') {

          var path = $attr.contentPath + uteLocale.language + '_' + uteLocale.province + '.html' ,
            markUpUrl = uteEndpoint(path, 'cms');

          $http.get(markUpUrl)
            .success(function (result) {

              $element.html(result);

              $compile($element.contents())($scope);

            }).error(function (data) {

            });

        }

      }
    };

  }]);

})();
